export const BS_TEST = 'behavioral-stress';
export const RR_TEST = 'retirement-regret';
export const LA_TEST = 'loss-aversion';
export const GOALS = 'goals';
export const NF_TEST = 'narrow-framing';
export const LF_TEST = 'loss-frequency';


// WEBPACK FOOTER //
// ./src/constants.js